import { APP_COLOR, DATA_GRID_CELL_HEIGHT } from '../common/Common.constants';
import { OptionType, ScheduleType } from '../common/Common.types';

export const DATA_GRID_STYLES: any = () => ({
  table: {
    '& tbody tr:nth-of-type(even)': {
      backgroundColor: APP_COLOR['field-grey'],
    },
    '& th:nth-child(2)': {
      paddingLeft: 5,
    },
    '& td:nth-child(2)': {
      paddingLeft: 5,
    },
    borderCollapse: 'collapse',
  },
  cell: {
    border: `1px solid ${APP_COLOR['border-grey']}`,
    fontFamily: 'Muli',
    color: APP_COLOR['table-header-text'], //NOSONAR
    fontWeight: 400,
    fontSize: 13,
    borderBottom: 0,
    paddingLeft: 18,
    height: DATA_GRID_CELL_HEIGHT,
  },
  bandCell: {
    border: `1px solid ${APP_COLOR['border-grey']}`,
    fontFamily: 'Muli',
    color: APP_COLOR['table-header-text'],
    fontWeight: 400,
    fontSize: 10,
    borderBottom: 0,
    textAlign: 'center',
    backgroundColor: APP_COLOR['index-col-blue'],
    height: 40,
    padding: 0,
  },
  head: {
    '& th': {
      backgroundColor: APP_COLOR['table-header'],
      color: APP_COLOR['table-header-text'],
      fontFamily: 'Muli',
      fontWeight: 600,
      fontSize: 12,
      paddingLeft: 18,
    },
  },
  gridRoot: {
    height: '100%',
  },
});

export const INDEX_COL_STYLE: React.CSSProperties = {
  backgroundColor: APP_COLOR['index-col-blue'],
  textAlign: 'center',
  padding: 0,
  fontSize: 10,
  border: 0,
  borderLeft: '1px',
};

export const DATA_HEAP_REDACT_TEXT = { 'data-heap-redact-text': 'true' };

export const INDEX_COL_WIDTH = 40;

export const DEFAULT_LIMIT = 30;
export const DEFAULT_COLUMN_WIDTH = 200;
export const VIRTUAL_PAGE_SIZE = 25;
export const MAX_ROWS = 50000;
export const TABLE_HEIGHT_PERCENTAGE = 0.88;
export const EXCEL_FILE_NAME = 'DataGrid.xlsx';
export const SAVE_EXCEL_OPTIONS = { type: 'application/octet-stream' };
export const ROW_UNIQ_KEY = 'Customer ID';
export const FULL_ROWS_AMOUNT = 1000;
export const LAZY_LOADING_ACTION = {
  UPDATE_ROWS: 'UPDATE_ROWS',
  START_LOADING: 'START_LOADING',
  REQUEST_ERROR: 'REQUEST_ERROR',
  FETCH_INIT: 'FETCH_INIT',
  UPDATE_QUERY: 'UPDATE_QUERY',
};
export const NUMBER_MONTH_KEYWORD = [
  '',
  '',
  'other',
  'third',
  'fourth',
  'fifth',
  'sixth',
  'seventh',
  'eighth',
  'ninth',
  'tenth',
  'eleventh',
  'twelfth',
];
export const ADDITIONAL_DATA_DAY = 'th';
export const DEFAULT_VALUE_OF_WEEK = 1;
export const DEFAULT_UNKNOW_VALUE = '_';
export const DEFAULT_VALUE_OF_MONTH = 1;
export const DEFAULT_VALUE_OF_TIME = '9:00 AM';
export const DEFAULT_VALUE_OF_SPECIAL_DAY = 'firstBusinessDay';
export const INDEX_COL = 'index-col';
export const EXTRA_COL = 'extra-col';
export const MINIMUM_COLS = 15;
export const WITHOUT_TITLE_COLUMNS = [INDEX_COL, EXTRA_COL];

export const DEFAULT_WEEKLY_SCHEDULED_REPORT_VALUE = {
  scheduleType: ScheduleType.Weekly,
  interval: DEFAULT_VALUE_OF_WEEK,
  time: DEFAULT_VALUE_OF_TIME,
  scheduleTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
};

export const DEFAULT_MONTHLY_SCHEDULED_REPORT_VALUE = {
  interval: DEFAULT_VALUE_OF_WEEK,
  time: DEFAULT_VALUE_OF_TIME,
  dayOfMonth: DEFAULT_VALUE_OF_MONTH,
  scheduleType: ScheduleType.Monthly,
  specialDay: DEFAULT_VALUE_OF_SPECIAL_DAY,
  scheduleTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  radioNormal: true,
};

export const DEFAULT_SCHEDULED_REPORT_VALUE = {
  interval: DEFAULT_VALUE_OF_WEEK,
  time: DEFAULT_VALUE_OF_TIME,
  scheduleTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
};

export const DATA_MONTHLY_MAX_LENGTH = 2;
export const MAX_MONTH = 12;
export const MAX_DAY = 31;
export const DAY_LANGE = 28;
export const TIME_OPTIONS: OptionType[] = [
  { value: '0:00 AM', displayName: '0:00 AM' },
  { value: '0:30 AM', displayName: '0:30 AM' },
  { value: '1:00 AM', displayName: '1:00 AM' },
  { value: '1:30 AM', displayName: '1:30 AM' },
  { value: '2:00 AM', displayName: '2:00 AM' },
  { value: '2:30 AM', displayName: '2:30 AM' },
  { value: '3:00 AM', displayName: '3:00 AM' },
  { value: '3:30 AM', displayName: '3:30 AM' },
  { value: '4:00 AM', displayName: '4:00 AM' },
  { value: '4:30 AM', displayName: '4:30 AM' },
  { value: '5:00 AM', displayName: '5:00 AM' },
  { value: '5:30 AM', displayName: '5:30 AM' },
  { value: '6:00 AM', displayName: '6:00 AM' },
  { value: '6:30 AM', displayName: '6:30 AM' },
  { value: '7:00 AM', displayName: '7:00 AM' },
  { value: '7:30 AM', displayName: '7:30 AM' },
  { value: '8:00 AM', displayName: '8:00 AM' },
  { value: '8:30 AM', displayName: '8:30 AM' },
  { value: '9:00 AM', displayName: '9:00 AM' },
  { value: '9:30 AM', displayName: '9:30 AM' },
  { value: '10:00 AM', displayName: '10:00 AM' },
  { value: '10:30 AM', displayName: '10:30 AM' },
  { value: '11:00 AM', displayName: '11:00 AM' },
  { value: '11:30 AM', displayName: '11:30 AM' },
  { value: '12:00 PM', displayName: '12:00 PM' },
  { value: '12:30 PM', displayName: '12:30 PM' },
  { value: '1:00 PM', displayName: '1:00 PM' },
  { value: '1:30 PM', displayName: '1:30 PM' },
  { value: '2:00 PM', displayName: '2:00 PM' },
  { value: '2:30 PM', displayName: '2:30 PM' },
  { value: '3:00 PM', displayName: '3:00 PM' },
  { value: '3:30 PM', displayName: '3:30 PM' },
  { value: '4:00 PM', displayName: '4:00 PM' },
  { value: '4:30 PM', displayName: '4:30 PM' },
  { value: '5:00 PM', displayName: '5:00 PM' },
  { value: '5:30 PM', displayName: '5:30 PM' },
  { value: '6:00 PM', displayName: '6:00 PM' },
  { value: '6:30 PM', displayName: '6:30 PM' },
  { value: '7:00 PM', displayName: '7:00 PM' },
  { value: '7:30 PM', displayName: '7:30 PM' },
  { value: '8:00 PM', displayName: '8:00 PM' },
  { value: '8:30 PM', displayName: '8:30 PM' },
  { value: '9:00 PM', displayName: '9:00 PM' },
  { value: '9:30 PM', displayName: '9:30 PM' },
  { value: '10:00 PM', displayName: '10:00 PM' },
  { value: '10:30 PM', displayName: '10:30 PM' },
  { value: '11:00 PM', displayName: '11:00 PM' },
  { value: '11:30 PM', displayName: '11:30 PM' },
];

export const SPECIAL_DAYS_OPTIONS: OptionType[] = [
  { value: 'firstBusinessDay', displayName: 'First business day' },
  { value: 'lastBusinessDay', displayName: 'Last business day ' },
  { value: 'day1And15', displayName: '1st & 15th ' },
];

export const WEEKS = new Map<number, string>([
  [1, 'EVERY'],
  [2, 'EVERY_OTHER'],
  [3, 'EVERY_THIRD'],
  [4, 'EVERY_FOURTH'],
  [5, 'EVERY_FIFTH'],
  [6, 'EVERY_SIXTH'],
  [7, 'EVERY_SEVENTH'],
  [8, 'EVERY_EIGHTH'],
  [9, 'EVERY_NINTH'],
]);

export const DAYS = new Map<number, string>([
  [0, 'SUNDAY'],
  [1, 'MONDAY'],
  [2, 'TUESDAY'],
  [3, 'WEDNESDAY'],
  [4, 'THURSDAY'],
  [5, 'FRIDAY'],
  [6, 'SATURDAY'],
]);

export const SCROLL_EVENTS = ['mousewheel', 'touchmove'];
export const TABLE_CONTAINER_CLASS_NAME = 'TableContainer-root-2';
